import { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { API } from "@/App";
import logger from "@/utils/logger";
import { toast } from "sonner";
import ContactInfo from "./contact/ContactInfo";
import ContactForm from "./contact/ContactForm";
import FAQSection from "./contact/FAQSection";

const ContactPage = () => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/inquiries`, formData);
      toast.success(t("contact.toast.success"));
      setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (error) {
      logger.error("Error submitting inquiry:", error);
      toast.error(t("contact.toast.error"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="contact-page" className="min-h-screen bg-[#F4F1DE]">
      {/* Hero */}
      <section className="pt-32 pb-20 bg-[#3D405B] relative overflow-hidden" data-testid="contact-hero">
        <div className="absolute inset-0 opacity-10 pattern-bg"></div>
        <div className="max-w-7xl mx-auto px-6 text-center relative z-10">
          <span className="inline-block bg-[#F2CC8F]/20 text-[#F2CC8F] px-4 py-2 rounded-full text-sm font-medium mb-6">
            {t("contact.hero.badge")}
          </span>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 font-['Playfair_Display']">
            {t("contact.hero.title")}
          </h1>
          <p className="text-xl text-[#F4F1DE]/80 max-w-2xl mx-auto">
            {t("contact.hero.subtitle")}
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20" data-testid="contact-section">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <ContactInfo />
            <ContactForm
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleSubmit}
              submitting={submitting}
            />
          </div>
        </div>
      </section>

      <FAQSection />
    </div>
  );
};

export default ContactPage;
